import { useQuery } from '@tanstack/react-query';

import { useUserState } from '../context/UserContext';
import { type WrappedTRPCClient } from '../helpers/trpcClientTypes';

const DEFAULT = { followersCount: 0, followingCount: 0 };

const useFollowCounts = (client: WrappedTRPCClient) => {
  const { state } = useUserState();
  const { data } = useQuery({
    queryKey: ['users', 'followCounts'],
    queryFn: async () => {
      const [, d] = await client.users.followCounts.query();
      return d ?? DEFAULT;
    },
    enabled: state.user.isAuthenticated === true,
    staleTime: Infinity
  });
  return data ?? DEFAULT;
};

export default useFollowCounts;
